/** Shared pure pricing: primitive types only; no API DTO or framework dependencies. */
import { sayiYaz } from './cikti/sayi-yaz';

export interface KisiBasiFiyatModeli {
  readonly yetiskinMinor: number;
  readonly cocukMinor?: number;
  readonly safariYasKurali?: true;
}

export const SAFARI_YAS_NOTU = 'Safari: 0–2 yaş ücretsiz; 3–16 yaş kişi başı 90 USD; 17 yaş ve üzeri yetişkin fiyatı. 0–2 yaş için isteğe bağlı ek koltuk 90 USD.';
export const ARAC_KAPASITE_NOTU = 'Valiz kapasitesi nedeniyle 4 kişilik araçta en fazla 3 yetişkin ve toplam 4 yolcu taşınır.';
export const safariBebekSayisi = (yaslar: readonly number[]): number => yaslar.filter(y => y >= 0 && y <= 2).length;
export function safariKoltukGecerli(yaslar: readonly number[], koltuk: number, safariSecili: boolean): boolean {
  return Number.isInteger(koltuk) && koltuk >= 0 && koltuk <= safariBebekSayisi(yaslar) && (safariSecili || koltuk === 0);
}
export function kisiBasiHesapla(k: KisiBasiFiyatModeli, yetiskin: number, yaslar: readonly number[], para: string, bebekKoltuk = 0): { toplam: number; dayanak: string } {
  const safari = k.safariYasKurali === true;
  const adult = yetiskin + (safari ? yaslar.filter(y => y >= 17).length : 0);
  const child = safari ? yaslar.filter(y => y >= 3 && y <= 16).length : yaslar.length;
  const infant = safari ? safariBebekSayisi(yaslar) : 0;
  const childPaid = k.cocukMinor !== undefined && child > 0;
  const seats = safari ? bebekKoltuk : 0;
  const toplam = adult * k.yetiskinMinor + (childPaid ? child * k.cocukMinor! : 0) + seats * 9_000;
  const dayanak = `${String(adult)} yetişkin x ${sayiYaz(k.yetiskinMinor)} ${para} (kişi başı)`
    + (childPaid ? ` + ${String(child)} çocuk x ${sayiYaz(k.cocukMinor!)} ${para}${safari ? ' (3–16 yaş)' : ''}` : '')
    + (infant > 0 ? ` + ${String(infant)} bebek (0–2 yaş ücretsiz)` : '')
    + (seats > 0 ? ` + ${String(seats)} ek koltuk x 90 USD (0–2 yaş)` : '');
  return { toplam, dayanak };
}
